import queryClient from "app/config/queryClient";
import { axiosInterceptor } from "app/services/http-services/request-interceptor";

// Zera os dados de TODAS as queries sem removê-las: os observers montados (AuthProvider,
// TranslationProvider, menu) são notificados e nenhum dado do usuário anterior sobrevive.
export const wipeQueryCache = () => {
    queryClient.getQueryCache().findAll().forEach(query => query.reset());
};

class AuthService {
    private accessToken: string | null;

    constructor() {
        this.accessToken = null; // stored ONLY in memory
    }

    getAccessToken() {
        return this.accessToken;
    }

    setAccessToken(token: string | null) {
        this.accessToken = token;
    }

    async login(email: string, password: string) {
        const response = await axiosInterceptor.post("/auth/login", { sys_user: { email, password } });

        this.setAccessToken(response.data.access_token);
        // TranslationProvider may have cached a guest-scoped translation bundle on
        // the login page. Resetting every query clears that bundle and refetches
        // active observers with the new token, including session and translations.
        await queryClient.resetQueries();
        return response.data;
    }

    async refreshToken() {
        try {
            const response = await axiosInterceptor.post("/auth/refresh");
            const newToken = response.data.access_token;

            this.setAccessToken(newToken);
            return newToken;
        } catch (err) {
            this.logout();
            return null;
        }
    }

    clearSession() {
        this.accessToken = null;
    }

    async logout() {
        this.clearSession();
        try {
            await axiosInterceptor.delete("/auth/logout"); // Devise JWT revoke refresh token
        } finally {
            wipeQueryCache();
        }
    }
}

export const authService = new AuthService();
